import useFormatCurrencyForItinerary from '@/src/hooks/currency/useFormatCurrencyForItinerary'
import usePriceCalculation from '@/src/hooks/itinerary/usePriceCalculation'
import { useTranslations } from 'next-intl'
import PriceSummary from './priceSummary'

const PriceSummaryWrapper = () => {
    const { pricingItems, totalPrice, totalTravellers } = usePriceCalculation()
    const { formatCurrency } = useFormatCurrencyForItinerary()
    const tPricing = useTranslations('itineraryPage.pricing')
    const tCommon = useTranslations('common')
    return (
        <PriceSummary
            pricingItems={pricingItems}
            totalPrice={totalPrice}
            travellerCount={totalTravellers}
            formatCurrency={formatCurrency}
            tPricing={tPricing}
            tCommon={tCommon}
        />
    )
}

export default PriceSummaryWrapper
